import { MessageStyles } from "./message.styles";

const Message = ({
  isMyMessage,
  text,
  time,
  isFirstInGroup = true,
  isLastInGroup = true
}) => {
  const showAvatar = !isMyMessage && isLastInGroup;
  return (
    <MessageStyles
      $isMyMessage={isMyMessage}
      $isFirst={isFirstInGroup}
      $isLast={isLastInGroup}
    >
      {!isMyMessage && (
        <div className="avatarSlot" aria-hidden>
          {showAvatar && <div className="avatar">D</div>}
        </div>
      )}
      <div className="bubbleColumn">
        <div className="bubble">{text}</div>
        {isLastInGroup && <span className="time">{time}</span>}
      </div>
    </MessageStyles>
  );
};

export default Message;
